import { KoAPI } from 'packages';

const BASE = '/v1/apiplatform';
const SERVICES_BASE = `${BASE}/services`;
const ENDPOINTS_BASE = `${BASE}/endpoints`;
const COLLECTIONS_BASE = `${BASE}/collections`;
const ENVIRONMENTS_BASE = `${BASE}/environments`;
const TESTS_BASE = `${BASE}/test-suites`;
const AUDIT_BASE = `${BASE}/audit-logs`;

export const ApiPlatformAPI = {
  // ── Services ─────────────────────────────────────────────────
  getServices: (params) =>
    KoAPI.get(SERVICES_BASE, { params }),

  getServiceById: (id) =>
    KoAPI.get(`${SERVICES_BASE}/${id}`),

  createService: (data, id) =>
    id
      ? KoAPI.put(`${SERVICES_BASE}/${id}`, data)
      : KoAPI.post(SERVICES_BASE, data),

  deleteService: (id) =>
    KoAPI.delete(`${SERVICES_BASE}/${id}`),

  getServiceEndpoints: (serviceId) =>
    KoAPI.get(`${SERVICES_BASE}/${serviceId}/endpoints`),

  // ── Endpoints ────────────────────────────────────────────────
  getEndpoints: (params) =>
    KoAPI.get(ENDPOINTS_BASE, { params }),

  getEndpointById: (id) =>
    KoAPI.get(`${ENDPOINTS_BASE}/${id}`),

  createEndpoint: (data, id) =>
    id
      ? KoAPI.put(`${ENDPOINTS_BASE}/${id}`, data)
      : KoAPI.post(ENDPOINTS_BASE, data),

  deleteEndpoint: (id) =>
    KoAPI.delete(`${ENDPOINTS_BASE}/${id}`),

  testEndpoint: (id, payload) =>
    KoAPI.post(`${ENDPOINTS_BASE}/${id}/test`, payload),

  // ── Explorer ─────────────────────────────────────────────────
  executeRequest: (payload) =>
    KoAPI.post(`${BASE}/explorer/execute`, payload),

  getSavedRequests: (params) =>
    KoAPI.get(`${BASE}/explorer/requests`, { params }),

  saveRequest: (data, id) =>
    id
      ? KoAPI.put(`${BASE}/explorer/requests/${id}`, data)
      : KoAPI.post(`${BASE}/explorer/requests`, data),

  deleteRequest: (id) =>
    KoAPI.delete(`${BASE}/explorer/requests/${id}`),

  // ── Collections ──────────────────────────────────────────────
  getCollections: (params) =>
    KoAPI.get(COLLECTIONS_BASE, { params }),

  getCollectionById: (id) =>
    KoAPI.get(`${COLLECTIONS_BASE}/${id}`),

  createCollection: (data, id) =>
    id
      ? KoAPI.put(`${COLLECTIONS_BASE}/${id}`, data)
      : KoAPI.post(COLLECTIONS_BASE, data),

  deleteCollection: (id) =>
    KoAPI.delete(`${COLLECTIONS_BASE}/${id}`),

  runCollection: (id, envId) =>
    KoAPI.post(`${COLLECTIONS_BASE}/${id}/run`, { environmentId: envId }),

  getCollectionRuns: (id, params) =>
    KoAPI.get(`${COLLECTIONS_BASE}/${id}/runs`, { params }),

  // ── Environments ─────────────────────────────────────────────
  getEnvironments: (params) =>
    KoAPI.get(ENVIRONMENTS_BASE, { params }),

  getEnvironmentById: (id) =>
    KoAPI.get(`${ENVIRONMENTS_BASE}/${id}`),

  createEnvironment: (data, id) =>
    id
      ? KoAPI.put(`${ENVIRONMENTS_BASE}/${id}`, data)
      : KoAPI.post(ENVIRONMENTS_BASE, data),

  deleteEnvironment: (id) =>
    KoAPI.delete(`${ENVIRONMENTS_BASE}/${id}`),

  getEnvironmentVariables: (envId) =>
    KoAPI.get(`${ENVIRONMENTS_BASE}/${envId}/variables`),

  setEnvironmentVariable: (envId, data) =>
    KoAPI.post(`${ENVIRONMENTS_BASE}/${envId}/variables`, data),

  deleteEnvironmentVariable: (envId, varId) =>
    KoAPI.delete(`${ENVIRONMENTS_BASE}/${envId}/variables/${varId}`),

  // ── Contract Diff ────────────────────────────────────────────
  getContractDiff: (params) =>
    KoAPI.get(`${BASE}/contract-diff`, { params }),

  compareVersions: (serviceId, v1, v2) =>
    KoAPI.get(`${SERVICES_BASE}/${serviceId}/diff`, { params: { v1, v2 } }),

  getBreakingChanges: (params) =>
    KoAPI.get(`${BASE}/contract-diff/breaking`, { params }),

  // ── Release Tests ────────────────────────────────────────────
  getTestSuites: (params) =>
    KoAPI.get(TESTS_BASE, { params }),

  getTestSuiteById: (id) =>
    KoAPI.get(`${TESTS_BASE}/${id}`),

  createTestSuite: (data, id) =>
    id
      ? KoAPI.put(`${TESTS_BASE}/${id}`, data)
      : KoAPI.post(TESTS_BASE, data),

  deleteTestSuite: (id) =>
    KoAPI.delete(`${TESTS_BASE}/${id}`),

  runTestSuite: (id, envId) =>
    KoAPI.post(`${TESTS_BASE}/${id}/run`, { environmentId: envId }),

  getTestResults: (suiteId) =>
    KoAPI.get(`${TESTS_BASE}/${suiteId}/results`),

  getTestHistory: (suiteId, params) =>
    KoAPI.get(`${TESTS_BASE}/${suiteId}/history`, { params }),

  // ── Audit Logs ───────────────────────────────────────────────
  getAuditLogs: (params) =>
    KoAPI.get(AUDIT_BASE, { params }),

  getAuditLogById: (id) =>
    KoAPI.get(`${AUDIT_BASE}/${id}`),

  // ── Lists (for dropdowns) ────────────────────────────────────
  getServiceList: (params) =>
    KoAPI.get(`${SERVICES_BASE}/list`, { params }),

  getEndpointList: (serviceId) =>
    KoAPI.get(`${SERVICES_BASE}/${serviceId}/endpoints/list`),

  getEnvironmentList: (params) =>
    KoAPI.get(`${ENVIRONMENTS_BASE}/list`, { params })
};
